import { $apiClient } from 'utils/request';
import { ActionTriggerProps, ActionSampleTriggerProps } from './types';

export function newsService(payload: ActionTriggerProps) {
  const category = payload.category ? `&category=${payload.category}` : '';

  const url =
    `api/v1/content/news?page=${payload.page}&per_page=${payload.perPage}` +
    category;
  return $apiClient.get(url);
}

export function newsSampleService(payload: ActionSampleTriggerProps) {
  const url = `api/v1/content/news/${payload.slug}`;
  return $apiClient.get(url);
}
